var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbot = function SvgChatbot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chatbot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#chatbot_svg__b)",
    d: "M14 1.5a.75.75 0 0 1 .75.75V3h4.5A2.75 2.75 0 0 1 22 5.75v5.5c0 .485-.125.94-.346 1.336l-.165-.497a1.7 1.7 0 0 0-.59-.8 1.64 1.64 0 0 0-1.9 0 1.66 1.66 0 0 0-.58.78L18 13.62q-.064.2-.165.381H8.75A2.75 2.75 0 0 1 6 11.25v-5.5A2.75 2.75 0 0 1 8.75 3h4.5v-.75A.75.75 0 0 1 14 1.5m.3 14.59a1 1 0 0 1 .066-.09H6.75A2.75 2.75 0 0 0 4 18.75v.75c0 1.977.961 3.642 2.717 4.78C8.444 25.397 10.917 26 14 26s5.556-.602 7.283-1.72q.136-.09.268-.183a1.3 1.3 0 0 1-.302-.308A1.4 1.4 0 0 1 21 23a1.4 1.4 0 0 1 .06-.38l-.13.11a1.64 1.64 0 0 1-1.86 0 1.7 1.7 0 0 1-.59-.8l-.5-1.53a2 2 0 0 0-.34-.64 2 2 0 0 0-.18-.21 2.25 2.25 0 0 0-.83-.52l-1.56-.5a1.55 1.55 0 0 1-.77-.59 1.58 1.58 0 0 1 0-1.85M11 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m7.5-1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-.329 10.328c.347.349.607.773.761 1.24l.498 1.529a.605.605 0 0 0 1.14 0l.498-1.53a3.15 3.15 0 0 1 1.998-1.996l1.53-.497a.604.604 0 0 0 0-1.14l-.03-.008-1.531-.497a3.15 3.15 0 0 1-1.998-1.996l-.497-1.53a.604.604 0 0 0-1.14 0l-.498 1.53-.013.038a3.15 3.15 0 0 1-1.955 1.958l-1.53.497a.604.604 0 0 0 0 1.14l1.53.497c.467.155.89.418 1.237.765m8.65 3.53.918.298.019.004a.362.362 0 0 1 0 .684l-.919.298a1.9 1.9 0 0 0-1.198 1.198l-.299.918a.363.363 0 0 1-.684 0l-.299-.918a1.89 1.89 0 0 0-1.198-1.202l-.919-.298a.362.362 0 0 1 0-.684l.919-.298a1.9 1.9 0 0 0 1.18-1.198l.299-.918a.363.363 0 0 1 .684 0l.298.918a1.89 1.89 0 0 0 1.199 1.198"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chatbot_svg__b",
    x1: 16.001,
    x2: 16.001,
    y1: 1.5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1177FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#4394FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#1D77EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chatbot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgChatbot;